export default __webpack_public_path__ + "static/char-s-48-ja-b439b4ef3363181e8fdb9c4e605edd95.webp";